import * as React from 'react';

import styled from 'styled-components';

import Flag from '@components/basics/flag';
import DropdownItem, {
  DropdownItemProps,
} from '@components/form/dropdown/dropdown-item';
import UnselectedIcon from '@components/basics/icons/unselected';
import CompletedIcon from '@components/basics/icons/achievements-icons/completed';

interface DropdownItemFlag extends DropdownItemProps {
  className?: string;
  countryName: string;
  countryCode: string;
  countryId: string;
  selected?: boolean;
}

export const DropdownItemFlag: React.FC<DropdownItemFlag> = (props) => {
  return (
    <DropdownItem
      className={props.className}
      helpText={props.countryName}
      onClick={props.onClick}
      decoration={
        <Flag
          className="dropdown-item-flag"
          bigFlag
          countryCode={props.countryId}
        />
      }
      rightDecoration={
        props.selected ? (
          <CompletedIcon className="icon" />
        ) : (
          <UnselectedIcon className="icon" />
        )
      }
    >
      {`+${props.countryCode}`}
    </DropdownItem>
  );
};

export default styled(DropdownItemFlag)`
  .icon {
    width: 24px;
    height: 24px;
  }
`;
